import { store } from '../redux/store';

export const getProjectState = () => store.getState().projectState;
export const getGanttVisualizationConfig = () =>
  store.getState().ganttState.visualizationConfig;
export const getUserPreferenceTableGantt = () =>
  store.getState().ganttState.userPreferenceTableGantt;

// Nuevos selectores para tags, responsables y subcontracts
export const getTags = () => store.getState().tagState?.allTags || [];
export const getResponsables = () =>
  store.getState().responsableState?.allResponsables || [];
export const getSubcontracts = () =>
  store.getState().subcontractState?.allSubcontracts || [];
export const getCompanySettingsState = () =>
  store.getState().companySettingsState;
export const getCopyPasteState = () => store.getState().copyPasteState;
export const getLastUniqueCorrelativeIds = () =>
  store.getState().ganttState.lastUniqueCorrelativeIds;
